import React, { useState } from 'react'

import {
  AlertCard,
  AlertCardContent,
  AlertCardVariant,
  Button,
  Color,
  Spinner,
} from '@gousto-internal/citrus-react'
import PropTypes from 'prop-types'

import css from './OrderRestoreButton.css'

const OrderRestoreButton = (props) => {
  const {
    pending,
    error,
    orderId,
    userId,
    deliveryDayId,
    deliveryDay,
    projectedOrderRestore,
    orderState,
    restoreCancelledOrder,
    isProjected,
  } = props

  const [selectedOrder, setSelectedOrder] = useState(null)

  const handleRestoreBox = () => {
    if (orderState === 'cancelled' && !isProjected) {
      restoreCancelledOrder(orderId)
    } else {
      projectedOrderRestore(orderId, userId, deliveryDayId, deliveryDay)
    }

    setSelectedOrder(orderId)
  }

  const isCurrentOrder = selectedOrder === orderId
  const isLoading = pending && isCurrentOrder

  return (
    <div>
      {error ? (
        <AlertCard variant={AlertCardVariant.Warning} data-testid="restoreError">
          <AlertCardContent>
            Whoops, there was a problem restoring this order, please try again.
          </AlertCardContent>
        </AlertCard>
      ) : null}
      <div className={css.button}>
        <Button
          onClick={() => handleRestoreBox()}
          disabled={isLoading}
          data-testing="restoreButton"
        >
          {isLoading ? <Spinner color={Color.White} size={6} /> : 'Restore delivery'}
        </Button>
      </div>
    </div>
  )
}

OrderRestoreButton.propTypes = {
  userId: PropTypes.string,
  orderId: PropTypes.string,
  deliveryDayId: PropTypes.string,
  deliveryDay: PropTypes.string,
  projectedOrderRestore: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  restoreCancelledOrder: PropTypes.func,
  error: PropTypes.string,
  pending: PropTypes.bool,
  orderState: PropTypes.string.isRequired,
  isProjected: PropTypes.bool,
}

OrderRestoreButton.defaultProps = {
  userId: '',
  orderId: '',
  deliveryDayId: '',
  deliveryDay: '',
  error: null,
  pending: false,
  isProjected: false,
  projectedOrderRestore: () => {
    /* noop */
  },
  restoreCancelledOrder: () => {
    /* noop */
  },
}

export default OrderRestoreButton
